<template>
  <div
    class="toast toast-selector fade popup text-start"
    aria-live="assertive"
    aria-atomic="true"
    ref="modal"
    :style="{
      top: modelValueData.pos_y + '%',
      left: modelValueData.pos_x + '%',
    }"
  >
    <div class="toast-header">
      <strong class="me-auto"> Select product </strong>
      <button
        type="button"
        class="btn-close"
        v-on:click="closeModal"
        :aria-label="$t(`orderChange.close`)"
      ></button>
    </div>
    <div class="toast-body" ref="body">
      <ProductSelector
        :always-edit="true"
        type="products"
        v-model="modelValueData.product"
      />
      <div class="d-flex justify-content-between mt-3">
        <button class="btn btn-primary" v-on:click="save()">Save</button>
        <button
          class="btn btn-outline-danger"
          v-if="modelValueData.id"
          v-on:click="remove()"
        >
          Delete
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ProductSelector from "../lists/listItems/ProductSelector.vue";

const bootstrap = require("bootstrap");

export default {
  name: "ProductSelectorToast",
  props: {
    modelValue: Object,
    show: Boolean,
  },
  emits: ["update:modelValue", "update:show", "change", "delete"],
  data: function () {
    return {
      modelValueData:
        typeof this.modelValue === "object"
          ? Object.assign({}, this.modelValue)
          : {},
    };
  },
  mounted() {
    let myModal = new bootstrap.Toast(this.$refs.modal, { autohide: false });
    if (this.show) {
      myModal.show();
    } else {
      myModal.hide();
    }
  },
  methods: {
    save() {
      this.$emit("update:modelValue", this.modelValueData);
      this.$emit("change");
    },
    remove() {
      this.$emit("delete");
    },
    closeModal(checkFocus = false) {
      if (checkFocus) {
        if (this.$refs.body.contains(document.activeElement)) {
          return;
        }
        const _this = this;
        setTimeout(function () {
          if (_this.$refs.body.contains(document.activeElement)) {
            return;
          }
          _this.$emit("update:show", false);
        }, 400);
      } else {
        this.$emit("update:show", false);
      }
    },
  },
  watch: {
    modelValue: {
      deep: true,
      handler() {
        this.modelValueData =
          typeof this.modelValue === "object"
            ? Object.assign({}, this.modelValue)
            : {};
      },
    },
    show() {
      let myModal = new bootstrap.Toast(this.$refs.modal, { autohide: false });
      if (this.show) {
        myModal.show();
      } else {
        myModal.hide();
      }
    },
  },
  components: { ProductSelector },
};
</script>
<style scoped>
.toast-selector {
  position: absolute;
  transform: translate(-50%, -50%);
}
</style>
